const LOGOS = { 'mondial relay': 'mondial-relay', colissimo: 'colissimo', chronopost: 'chronopost', dpd: 'dpd', ups: 'ups', gls: 'gls' };

// Public logo path for a carrier name (served from /public/carriers), null when unknown
export const carrierLogo = (name) => {
  const key = Object.keys(LOGOS).find(k => String(name || '').toLowerCase().includes(k));
  return key ? `/carriers/${LOGOS[key]}.png` : null;
};
